import { render, staticRenderFns } from "./VLoadSpinner.vue?vue&type=template&id=ec4fce8a&scoped=true"
import script from "./VLoadSpinner.vue?vue&type=script&lang=js"
export * from "./VLoadSpinner.vue?vue&type=script&lang=js"
import style0 from "./VLoadSpinner.vue?vue&type=style&index=0&id=ec4fce8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec4fce8a",
  null
  
)

export default component.exports